import { render } from "./DashboardArmazenagemTotal.vue?vue&type=template&id=7482aa81"
import script from "./DashboardArmazenagemTotal.vue?vue&type=script&lang=js"
export * from "./DashboardArmazenagemTotal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__